export default "__VITE_ASSET__C8UweKyN__"